<template>
  <div class="xueqiu-news-container">
    <h3>雪球新闻</h3>
    <!-- 新增刷新控制栏 -->
    <el-form :inline="true" :model="form" class="refresh-control">
      <el-form-item label="刷新间隔">
        <el-input-number
          v-model="refreshInterval"
          :min="10"
          :max="3600"
          :step="10"
          controls-position="right"
          size="small"
        >
          <template #append>
            <span>秒</span>
          </template>
        </el-input-number>
      </el-form-item>

      <el-form-item label="自动刷新">
        <el-switch
          v-model="isAutoRefresh"
          active-text="开启"
          inactive-text="暂停"
          @change="handleRefreshSwitch"
        />
      </el-form-item>
         <el-form-item label="雪球 Cookie">
    <el-input v-model="form.cookie" size="small" style="width: 300px;" placeholder="请输入 Cookie" />
  </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          @click="manualRefresh"
          :disabled="loading"
        >
          <i class="el-icon-refresh"></i>
          立即刷新
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 新闻列表 -->
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card v-for="item in newsList" :key="item.id" class="news-item">
          <template #header>
            <div class="news-header">
              <h3 class="news-title">{{ extractTitle(item.text) }}</h3>
              <span class="news-time">{{ formatTime(item.created_at) }}</span>
            </div>
          </template>
          <p class="news-content">{{ extractContent(item.text) }}</p>
          <div class="news-footer">
            <span class="interaction-item">
              <i class="el-icon-chat-dot-round"></i>
              {{ item.reply_count }} 评论
            </span>
            <span class="interaction-item">
              <i class="el-icon-share"></i>
              {{ item.share_count }} 分享
            </span>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import axios from 'axios';

export default {
  data() {
    return {
      newsList: [],
      nextMaxId: null,
      refreshInterval: 15, // 默认15秒
      isAutoRefresh: true, // 自动刷新状态
      timerId: null, // 定时器ID
      loading: false, // 加载状态
      form: {
          cookie: localStorage.getItem('xueqiu_cookie') || '' // 初始化 cookie
      }
    };
  },
  mounted() {
    this.fetchNews(true);
  },
  methods: {
    handleRefreshSwitch(isActive) {
      if (isActive) {
        this.startAutoRefresh();
        this.$message.success(`已开启自动刷新，间隔${this.refreshInterval}秒`);
      } else {
        this.stopAutoRefresh();
        this.$message.info('已暂停自动刷新');
      }
    },

    startAutoRefresh() {
      this.stopAutoRefresh(); // 先停止已有定时器
      this.timerId = setInterval(() => {
        if (!this.loading) {
          this.fetchNews(true);
        }
      }, this.refreshInterval * 1000);
    },

    stopAutoRefresh() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    },

    manualRefresh() {
      if (!this.loading) {
        this.fetchNews(true);
        this.$message.success('手动刷新成功');
      }
    },

    extractTitle(text) {
      const match = text.match(/【(.*?)】/);
      return match ? match[1] : text.slice(0, 20) + '...';
    },

    extractContent(text) {
      return text.replace(/【(.*?)】/g, '');
    },

    formatTime(timestamp) {
      return dayjs(timestamp).format('YYYY-MM-DD HH:mm');
    },

    async fetchNews(isRefresh = false) {
      try {
        this.loading = true;
        const cookie = localStorage.getItem('xueqiu_cookie') || '__utmz=1.1709877910.1.1.utmcsr=(direct)|utmccn=(direct)|utmcmd=(none); cookiesu=111740962553404; device_id=98010cd28892388314062826e479ee22; s=c01u1pl55s; Hm_lvt_1db88642e346389874251b5a1eded6e3=1758243656,1760057404; HMACCOUNT=3B2844D10F77CAA2; remember=1; xq_a_token=b9aff3c7027b3a096bfc24c925d7750a51f7ece5; xqat=b9aff3c7027b3a096bfc24c925d7750a51f7ece5; xq_id_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ1aWQiOjExNzcxNjQ4OTEsImlzcyI6InVjIiwiZXhwIjoxNzYyNjQ5NDMxLCJjdG0iOjE3NjAwNTc0MzE2NTUsImNpZCI6ImQ5ZDBuNEFadXAifQ.n5HDMxy6Awm0teIOOFuayTVsJVtm8c4CJolhQJQdPZfE7HXUKmGO6xuUp3MbZXnMt3FZQYf_mFfj0o3aaA1F7AB_SeoHBwprcPI63sm0VnB16mETe49lISmOAagDQhbzCb2PR1v0sblMUPB0mxnkeOZxMJwmGKiZd-jcAeHnsvadMmdPgrLS-WU3rzI1sBG4ma9oLLbAgGIWrKrzRLUreHVtORk6v0pnyVD_wvA2cuAzOEwTTe8iHtnePz5ySjZcQdU66mAhuVhSXbRQx1x9rhidtfSpNfLrBKtYFG85vvZ2S1E8c9zHsUggsPHpz25fddQBwZDAy5oqx_VP-ZO9Bg; xq_r_token=a43d0ecad5560ec5ff002bddb640998e22f90464; xq_is_login=1; u=1177164891; Hm_lpvt_1db88642e346389874251b5a1eded6e3=1760057508';

        const params = {
          count: 15,
          cookie: cookie
        };

        const { data } = await axios.post('/api/xueqiu', params);

        if (isRefresh) {
          this.newsList = [...this.newsList, ...data.items];
        } else {
          this.newsList = data.items;
        }
        // 保持分页状态
      } catch (error) {
        console.error('获取雪球新闻数据失败', error);
        this.$message.error('获取新闻数据失败');
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    refreshInterval(newVal) {
      if (this.isAutoRefresh) {
        this.startAutoRefresh();
        this.$message.success(`刷新间隔已调整为${newVal}秒`);
      }
    },
  },
  beforeUnmount() {
    this.stopAutoRefresh();
  },
};
</script>

<style scoped>
.xueqiu-news-container {

  margin: 0 auto;
  padding: 20px;
}

.refresh-control {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
  margin-bottom: 20px;
  padding: 10px 15px;
  background: #f5f7fa;
  border-radius: 4px;
}

.el-input-number {
  width: 120px;
}

.el-input-number ::v-deep .el-input__inner {
  text-align: left;
}

.news-item {
  margin-bottom: 20px;
}

.news-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.news-title {
  font-size: 18px;
  color: #333;
  margin: 0;
  flex: 1;
}

.news-time {
  color: #999;
  font-size: 14px;
}

.news-content {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
}

.news-footer {
  border-top: 1px solid #eee;
  padding-top: 10px;
  display: flex;
  gap: 20px;
}

.interaction-item {
  color: #909399;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

@media (max-width: 768px) {
  .refresh-control {
    flex-direction: column;
    align-items: flex-start;
  }

  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
